import { Input, Modal, Spin } from 'antd'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { EyeOutlined, DownloadOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea'
// import { Content } from 'antd/es/layout/layout'
import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
// import { ShowComingSoon } from '../../../functions/Utils'
import { updatenotificationdata } from '../../../store/Admin/Common/CommonSlice'
import { kyc_verification } from '../../../store/Admin/KYC/KYCVerificationSlice'
import { ButtonSubmit, ButtonView, CustomeButton, DocButton } from '../../../StyledComponents/Common'
import { ButtonSection, ContentRow, ContentTitle, ContentValue, DetailContentContainer } from '../../../StyledComponents/CreateKeyAccountManager'
// import { IconImg } from '../../StyledComponents/Header'
import { DocInput } from '../../../StyledComponents/KYCVerifications'
// import AddButton from '../Common/AddButton'
import SubmitButton from '../Common/SubmitButton'
import { httpinstance } from '../../../axios/api'
// import UploadButton from '../Common/UploadButton'
// import UploadDocs from '../Common/UploadDocs'

function DocumentDetails(props) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [activeButton, setActiveButton] = useState("");
    const [acceptLoading, setAcceptLoading] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [showValidation, setValidation] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [docActionLoading, setDocActionLoading] = useState(null);
    const [rejectModal, setRejectModal] = useState({ open: false, doc: null });
    const [docRejectReason, setDocRejectReason] = useState("");
    const [docRejectValidation, setDocRejectValidation] = useState(false);
    const downloadLinkRef = useRef(null);
    console.log(props,props.instance?.kyc_user?.accept_or_reject,"props")
    const handleArchive = () => {
        console.log("archive");
    }
    useEffect(()=> {
        if(props.instance?.kyc_user?.reason_rejection){
            setRejectReason(props.instance?.kyc_user?.reason_rejection)
        }
        if(props.instance?.documents){
            setDocuments(props.instance.documents)
        }
    },[props.instance])
    const handleViewDoc = (imageUrl) => {
        if(imageUrl){
            window.open(imageUrl, '_blank');
        }
      };


    // const handleDownload = async (imageUrl, file) => {
    //     if (!imageUrl) return;

    //     const urlWithoutQuery = imageUrl.split('?')[0];
    //     const rawFileName = urlWithoutQuery.split('/').pop() || file || 'document';

    //     try {
    //         // Fetch as a blob so the download works even for cross-origin URLs.
    //         // The anchor `download` attribute is ignored for cross-origin hrefs,
    //         // which otherwise causes the browser to just open the file.
    //         const response = await fetch(imageUrl);
    //         if (!response.ok) throw new Error('Failed to fetch file');
    //         const blob = await response.blob();
    //         const blobUrl = window.URL.createObjectURL(blob);

    //         const link = document.createElement('a');
    //         link.href = blobUrl;
    //         link.download = rawFileName;
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);

    //         window.URL.revokeObjectURL(blobUrl);
    //     } catch (err) {
    //         console.error('Download failed:', err);
    //         message.error('Unable to download the file');
    //     }
    // };
   
async function handleDownload(url) {
    // Guard against missing/invalid URLs so url.split(...) never throws.
    if (!url || typeof url !== 'string') {
        toast.error('Document is not available for download.');
        return;
    }
    // Derive a filename from the URL, dropping any query string, with a fallback.
    const fileNames = url.split('?')[0].split('/').pop() || 'document';
    try {
        const response = await httpinstance.get(`/admin/imgdownload`, {
            params: { url },
            responseType: "blob",
        });

        const blobUrl = URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileNames;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    } catch (err) {
        console.error("Download error:", err);
        toast.error(err?.response?.data?.message || "Unable to download the document. Please try again.");
    }
}

    const handleDocAction = async (action, doc, reason) => {
        const payload = {
            _id: props?.instance?._id,
            document_id: doc?._id,
            is_accepted: action === "accept",
            is_rejected: action === "reject",
        }
        if (action === "reject") {
            payload.reason = reason
        }
        setDocActionLoading(doc?._id)
        try {
            const res = await httpinstance.post('/update_kyc_document_status', payload)
            if (res?.data?.statusCode === 200) {
                // Re-render the documents list from the full updated KYC record
                if (res?.data?.data?.documents) {
                    setDocuments(res.data.data.documents)
                }
                toast.success(res?.data?.message || "Document status updated successfully")
                closeRejectModal()
            } else {
                toast.error(res?.data?.message || "Something went wrong")
            }
        } catch (err) {
            console.error("update_kyc_document_status error:", err)
            toast.error(err?.response?.data?.message || "Unable to update document status")
        } finally {
            setDocActionLoading(null)
        }
    }

    const openRejectModal = (doc) => {
        setDocRejectReason(doc?.reason || "")
        setDocRejectValidation(false)
        setRejectModal({ open: true, doc })
    }

    const closeRejectModal = () => {
        setRejectModal({ open: false, doc: null })
        setDocRejectReason("")
        setDocRejectValidation(false)
    }

    const submitRejectDoc = () => {
        if (!docRejectReason.trim()) {
            setDocRejectValidation(true)
            return
        }
        handleDocAction("reject", rejectModal.doc, docRejectReason.trim())
    }

    // A document counts as "reviewed" only when is_accepted === true OR
    // is_rejected === true. If both are false the doc is untouched.
    // Buttons are shown only when EVERY document has been reviewed:
    //   - all documents accepted            -> show ONLY "Accept KYC"
    //   - at least one document rejected     -> show ONLY "Reject KYC"
    //     (covers all-rejected and mixed accepted/rejected cases)
    // If any document still has both flags false, neither button is shown.
    const allDocsReviewed = documents.length > 0 && documents.every((d)=> d?.is_accepted === true || d?.is_rejected === true)
    const anyDocRejected = documents.some((d)=> d?.is_rejected === true)
    const allDocsAccepted = allDocsReviewed && !anyDocRejected
    const showAcceptKyc = allDocsAccepted
    const showRejectKyc = allDocsReviewed && anyDocRejected

    // Once the KYC is Accepted the document review is final: hide the reject
    // (cross) action and disable the accept (tick) action from further clicks.
    const isKycAccepted = props.instance?.kyc_user?.accept_or_reject === "Accepted"

    const handleDoc = (type) => {
        // Prevent double submission while a request is already in flight.
        if(acceptLoading || rejectLoading){
            return
        }
        if(type === 'accept_kyc' && !showAcceptKyc){
            toast.error("All documents must be accepted before accepting the KYC.")
            return
        }
        if(type === 'reject_kyc' && !showRejectKyc){
            toast.error("All documents must be reviewed, with at least one rejected, before rejecting the KYC.")
            return
        }
        {
            setActiveButton(type)
            let values = {
                kyc_action: type,
                user_id: props?.instance?.kyc_user?._id
            }
            console.log(values,props);
            if(type === 'accept_kyc'){
                setAcceptLoading(true)
            } else if(type === 'reject_kyc'){
                setRejectLoading(true)
                values.reason_for_rejection = rejectReason
            }
            dispatch(kyc_verification(values))
            .then(res=>{
                if(res?.payload?.data?.statusCode === 200 ){
                    console.log(res?.payload);
                    dispatch(updatenotificationdata(res?.payload?.data))
                    setRejectReason("")
                    props.setPageType("table")
                    navigate("/kyc-verification")
                } else {
                    // Any non-200 response (400, 500, undefined, network-shaped
                    // rejection wrapped by the thunk, etc.) surfaces an error.
                    toast.error(res?.payload?.data?.message || "Something went wrong")
                }
                if(res?.payload?.data){
                    dispatch(updatenotificationdata(res?.payload?.data))
                }
            })
            .catch(err=>{
                console.error(err);
                toast.error(err?.message || "Something went wrong. Please try again.")
            })
            .finally(()=>{
                // Always clear the loaders so the buttons/overlay never get stuck,
                // regardless of success, error, or unexpected response shape.
                setAcceptLoading(false)
                setRejectLoading(false)
            })
        }

    }

  return (
    <>
        {(acceptLoading || rejectLoading) &&
            <LoaderOverlay>
                <Spin size="large" />
                <LoaderText>Submitting...</LoaderText>
            </LoaderOverlay>
        }
        <ToastContainer position="top-center" autoClose={7000} hideProgressBar />
        <DetailContentContainer>
            {documents?.length ?
            documents.map((i,index)=> { //json.parse
                    const reviewStatus = i?.is_accepted ? 'accept' : i?.is_rejected ? 'reject' : null
                    const isLoading = docActionLoading === i?._id
                    // The document can only be viewed/downloaded when its S3 URL is present.
                    const hasDownloadUrl = !!i?.full_path_name
                    return (
                    <DocReviewWrap key={i?._id ?? index}>
                        <DocRow className='documents mb-5' $review={reviewStatus}>
                            <ContentTitle className='document-title'>
                                {i.proof}
                            </ContentTitle>
                            <DocInput placeholder="Document Name" size='large' value={i.document_name} disabled style={{ flex: 1 }} />
                            <ActionGroup>
                                <ViewButton disabled={!hasDownloadUrl} onClick={()=> handleViewDoc(i?.full_path_name)}><EyeOutlined /></ViewButton>
                                <DownloadButton disabled={!hasDownloadUrl} onClick={()=> handleDownload(i?.full_path_name)}><DownloadOutlined /></DownloadButton>
                                <TickButton selected={reviewStatus === 'accept'} disabled={isLoading || isKycAccepted || reviewStatus === 'reject' || reviewStatus === 'accept'} onClick={()=> handleDocAction("accept", i)}><CheckOutlined /></TickButton>
                                {!isKycAccepted &&
                                    <CrossButton selected={reviewStatus === 'reject'} disabled={isLoading || reviewStatus === 'accept'} onClick={()=> openRejectModal(i)}><CloseOutlined /></CrossButton>
                                }
                            </ActionGroup>
                        </DocRow>
                        {i?.is_rejected && i?.reason ?
                            <RejectReasonText>Reason: {i.reason}</RejectReasonText>
                        : null}
                    </DocReviewWrap>
                    )
                })
            : null}
            <a ref={downloadLinkRef} style={{ display: 'none' }} />
            <Modal
                title="Reject Document"
                open={rejectModal.open}
                onCancel={closeRejectModal}
                onOk={submitRejectDoc}
                okText="Reject"
                okButtonProps={{ danger: true, loading: docActionLoading === rejectModal.doc?._id }}
                cancelButtonProps={{ disabled: docActionLoading === rejectModal.doc?._id }}
            >
                <SmallHead>State Reason for Rejection</SmallHead>
                <TextArea
                    rows={4}
                    maxLength={150}
                    className='mt-2'
                    value={docRejectReason}
                    onChange={(e)=> (setDocRejectReason(e.target.value), setDocRejectValidation(false))}
                    placeholder="e.g. Document is blurred"
                />
                {docRejectValidation ? <ValMsg>Reason is required</ValMsg> : null}
            </Modal>
            <ContentRow className='documents mb-5' >
                <ContentTitle className='doc-status'>
                    KYC Status
                </ContentTitle>
                <StatusText status={props.instance?.kyc_user?.accept_or_reject}>
                    {props.instance?.kyc_user?.accept_or_reject === "Processing" ? "Under verification" : props.instance?.kyc_user?.accept_or_reject}
                </StatusText>
            </ContentRow>
            {props.instance?.kyc_user?.accept_or_reject === "Processing" ?
                <ContentRow className='flex-end mt-9 gap-4'>
                    {/* <UploadDocs class='active-button' /> */}
                    {showAcceptKyc &&
                        <DocButton className={activeButton === 'accept_kyc'? 'active-button': ''} onClick={()=> handleDoc("accept_kyc")} size='large' loading={acceptLoading} disabled={acceptLoading || rejectLoading}>Submit</DocButton>
                    }
                    {showRejectKyc &&
                        <DocButton className={activeButton === 'reject_kyc'? 'active-button': ''} onClick={()=> handleDoc("reject_kyc")} size='large' loading={rejectLoading} disabled={acceptLoading || rejectLoading}>Submit</DocButton>
                    }
                    {/* <DocButton className={activeButton === 'move_archives'? 'active-button': ''} onClick={()=> setActiveButton("move_archives")} size='large'>Move to Archives</DocButton> */}
                </ContentRow>
            :
                null
            }

        </DetailContentContainer>
        {/* {props.instance?.kyc_user?.accept_or_reject === "Rejected" ?
            <div className='mt-8'>
                <SmallHead>State Reason for Rejection</SmallHead>
                <DetailContentContainer className='mt-2'>
                    <TextArea rows={6} maxLength={150} value={rejectReason? rejectReason : ""} disabled placeholder="Type your message" style={{ position: 'relative' }} />
                </DetailContentContainer>
            </div>
        : null} */}

        {/* Old interactive reject-reason flow. Reject is now single-step (the
            "Submit" button rejects directly), so this Send-button flow is unused.
        {(activeButton === 'reject_kyc' && anyDocRejected) || props.instance?.kyc_user?.accept_or_reject === "Rejected" ?
            <div className='mt-8'>
                <SmallHead>State Reason for Rejection</SmallHead>
                <DetailContentContainer className='mt-2'>
                    <TextArea rows={6} maxLength={150} value={rejectReason? rejectReason : ""} disabled={props.instance?.kyc_user?.accept_or_reject === "Rejected"} onChange={(e)=> (setRejectReason(e.target.value),setValidation(false))} placeholder="Type your message" style={{ position: 'relative' }} />
                    {showValidation ? <ValMsg>Reason is Required</ValMsg>: null}
                </DetailContentContainer>
                {props.instance?.kyc_user?.accept_or_reject === "Rejected" ? null :
                    <SendButtonSection className='mt-3'>
                        <SubmitButton type='submit' title="Send" handleClick={()=> handleDoc("reject_kyc")} loading={rejectLoading} />
                    </SendButtonSection>
                }
            </div>
        : null}
        */}

    </>

  )
}

export default DocumentDetails

const LoaderOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(1px);
    cursor: wait;
    flex-direction: column;
    gap: 12px;
`
const LoaderText = styled.span`
    font-family: 'Roboto';
    font-weight: 600;
    font-size: 14px;
    color: #242424;
`
const SmallHead = styled.span`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    color: #242424;
`
const SendButtonSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`
const ValMsg = styled.span`
    color: red;
`
const StatusText = styled.span`
    color: ${({status})=> status === 'Accepted' ? '#08C004': status === 'Rejected'? '#FF3F3B' :status === 'Processing'? '#FFAF00':'#3F4254' };
    font-weight: 700;
`
const DocReviewWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
const RejectReasonText = styled.span`
    font-family: 'Roboto';
    font-size: 12px;
    font-weight: 500;
    color: #F1416C;
    margin: 0 0 20px 16px;
    flex: 1;
`
const DocRow = styled(ContentRow)`
    padding: 8px 14px;
    border-radius: 10px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
    background-color: ${({ $review }) => $review === 'accept' ? '#F0FDF6' : $review === 'reject' ? '#FFF0F3' : 'transparent'};
    box-shadow: ${({ $review }) => $review === 'accept' ? 'inset 3px 0 0 #17C653' : $review === 'reject' ? 'inset 3px 0 0 #F1416C' : 'none'};
`
const ActionGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
    flex-shrink: 0;
`
const DocActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid transparent;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
        transform: translateY(-1px);
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
`
const ViewButton = styled(DocActionButton)`
    color: #3699FF;
    background: #EEF6FF;
    &:hover {
        background: #3699FF;
        color: #FFFFFF;
    }
`
const DownloadButton = styled(DocActionButton)`
    color: #7239EA;
    background: #F3EFFF;
    &:hover {
        background: #7239EA;
        color: #FFFFFF;
    }
`
const TickButton = styled(DocActionButton)`
    color: ${({ selected }) => selected ? '#FFFFFF' : '#17C653'};
    background: ${({ selected }) => selected ? '#17C653' : '#E8FFF3'};
    box-shadow: ${({ selected }) => selected ? '0 2px 6px rgba(23, 198, 83, 0.4)' : 'none'};
    &:hover {
        background: #17C653;
        color: #FFFFFF;
    }
`
const CrossButton = styled(DocActionButton)`
    color: ${({ selected }) => selected ? '#FFFFFF' : '#F1416C'};
    background: ${({ selected }) => selected ? '#F1416C' : '#FFF0F3'};
    box-shadow: ${({ selected }) => selected ? '0 2px 6px rgba(241, 65, 108, 0.4)' : 'none'};
    &:hover {
        background: #F1416C;
        color: #FFFFFF;
    }
`